import type { ShallowRef } from 'vue'

import type { MemoryDecision, MemoryRecord, MemorySearchHit } from './velis-memory'

import { shallowRef } from 'vue'

export interface VelisMemoryGateway {
  read: () => Promise<{ records: MemoryRecord[], error?: string }>
  apply: (decision: MemoryDecision) => Promise<{ error?: string }>
  activity: () => Promise<{ entries: Array<MemoryDecision['trace'] & { error?: string }>, error?: string }>
  search?: (query: string) => Promise<{ hits: MemorySearchHit[], error?: string }>
}

interface MemoryBridgeSlot {
  activity: ShallowRef<MemoryDecision['trace'] | undefined>
  gateway?: VelisMemoryGateway
}

// NOTICE: Electron Vite can evaluate this module twice.
// One copy comes from the package export and the other from the chat store relative import.
// A module-local gateway then stays unset, so a real send never writes records.json.
// Remove the global slot when both imports resolve to one module instance.
function bridgeSlot(): MemoryBridgeSlot {
  const host = globalThis as typeof globalThis & { __velisMemoryBridge?: MemoryBridgeSlot }
  host.__velisMemoryBridge ??= { activity: shallowRef(undefined) }
  return host.__velisMemoryBridge
}

export const latestVelisMemoryActivity = bridgeSlot().activity

export function recordVelisMemoryActivity(decision: MemoryDecision) {
  latestVelisMemoryActivity.value = decision.trace
}

export function configureVelisMemoryGateway(nextGateway: VelisMemoryGateway | undefined) {
  bridgeSlot().gateway = nextGateway
}

export function getVelisMemoryGateway() {
  return bridgeSlot().gateway
}
